import { monthCodeToOffset } from "@package/grid-utils";
import type { Action } from "./types";

/**
 * Opens trace precedents modal for the selected cell.
 */
export const tracePrecedents: Action = (ctx) => {
  const product = ctx.productId;
  const row = ctx.rowId;
  if (!product || !row) return;

  const offset = monthCodeToOffset(row);
  if (typeof offset !== "number") return;

  const field = ctx.headerParams?.field ?? "value";

  ctx.tracePrecedentsModal.open({ product, row: offset, field });
};
